import * as React from "react"
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { rubik, bgdark, white, blue } from '../shared.module.css'
import Context from "../context"
import { useContext, useEffect } from 'react'

export function Head() {
	return (
		<>
			<title>Stanton – Industry Leading DJ Gear </title>
			<meta name="title" content="Stanton DJ " />
			<meta name="description" content="Stanton DJ are industry leaders in designing and manufacturing professional audio products for club and mobile DJs and turntablists. " />

			<meta property="og:type" content="website" />
			<meta property="og:url" content="https://stantondj.com/" />
			<meta property="og:title" content="Stanton DJ " />
			<meta property="og:description" content="Stanton DJ are industry leaders in designing and manufacturing professional audio products for club and mobile DJs and turntablists. " />
			<meta property="og:image" content="https://stantondj.com/stx.png" />

			<meta property="twitter:card" content="summary_large_image" />
			<meta property="twitter:url" content="https://stantondj.com/" />
			<meta property="twitter:title" content="Stanton DJ " />
			<meta property="twitter:description" content="Stanton DJ are industry leaders in designing and manufacturing professional audio products for club and mobile DJs and turntablists. " />
			<meta property="twitter:image" content='https://stantondj.com/stx.png' />
		</>
	)
}

export default function PrivacyPolicy() {
	const { setLocation, setName, setPrice, setLink } = useContext(Context)
    
    useEffect(() => {
        setLocation(null)
        setName('')
        setPrice('')
        setLink('')
    }, [setLocation, setName, setPrice, setLink])

	return (
		<Container fluid className={`${bgdark} ${white} ${rubik}`}>
			<Container>
				<Row className="py-md-5">
					<Col>
						<h1>inMusic Privacy Policy</h1>
						<p><em>Last Updated: 9 May 2025</em></p>
						<p>Thank you for visiting inMusic and its family of world-class audio performance, music technology
							and consumer electronics brands!</p>
						<p>At inMusic, we hear your concerns about privacy and are committed to protecting your
							information.&nbsp; inMusic has created this Privacy Policy to be transparent about how we
							collect, use, process and disclose your information, including personal information, when you
							access and use any of our websites.</p>
						<p>This policy applies to our hardware, software, applications, software and all inMusic websites,
							including Air Music Technology, Akai Professional, Alesis, Alto Professional, Denon DJ, Denon
							Professional, Headrush, ION Audio, Marantz Professional, MARQ, M-Audio, MixMeister, Numark, Rane
							and SONiVOX as well as any other website controlled and/or operated by inMusic.</p>
						<p>Please review this Privacy Policy carefully, as it describes the type of data we collect, how we
							use it and important legal rights you have.&nbsp; Covered below are the following topics:</p>
						<ul>
							<li><a href="#_TYPES_OF_INFORMATION" className={blue}>Types of Information We Collect</a></li>
							<li><a href="#_TYPICAL_CUSTOMER_INTERACTIONS" className={blue}>Typical Customer Interactions Where We May Collect Information</a></li>
							<li><a href="#_HOW_WE_USE" className={blue}>How We Use Information</a></li>
							<li><a href="#_HOW_WE_SHARE" className={blue}>How We Share Information</a></li>
							<li><a href="#_OUR_BASES_FOR" className={blue}>Our Bases for Using Your Information</a></li>
							<li><a href="#_SECURITY,_STORAGE_AND" className={blue}>Security, Storage and Retention of Information</a></li>
							<li><a href="#_YOUR_RIGHTS_AND" className={blue}>Your Rights and Choices</a></li>
							<li><a href="#_OUR_USE_OF" className={blue}>Our Use of Cookies and Similar Technologies</a></li>
							<li><a href="#_OUR_INTERNATIONAL_OPERATIONS" className={blue}>Our International Operations and Data Transfers</a></li>
							<li><a href="#_CHANGES_TO_THIS" className={blue}>Changes to This Privacy Policy</a></li>
							<li><a href="#_WHO_WE_ARE" className={blue}>Who We Are and How to Contact Us</a></li>
						</ul>
						<h2 id="_TYPES_OF_INFORMATION">TYPES OF INFORMATION WE COLLECT</h2>
						<h3>Information You Provide To Us</h3>
						<p>We collect information you voluntarily provide to us.&nbsp; For example, certain portions of our
							sites may require that you submit personal information, such as your name and email address,
							before using those portions of the site.&nbsp; You are also required to register with our sites
							and provide your name or email address before using any of the &ldquo;members only&rdquo; areas
							of our sites. For some services, such as forums, blogs, customer support features, registering
							products, for events or contests, downloading software or uploading content, you may have to
							create an account and submit additional personal information such as your mailing address.</p>
						<p>Some of our websites allow you to purchase hardware and/or software products. If you choose to
							make a purchase, you must provide certain payment information, including your name, credit or
							debit card number, card expiration date, CVV code, and billing address. This information is
							encrypted and sent to your card network, which upon approval sends back to our website a token,
							which is a set of random digits for engaging in transactions without exposing your card number.
							<strong>We do not store your payment information</strong>. We store your shipping address to
							fulfill your order. Note that third-party payment processors may retain this information in
							accordance with their own privacy policies and terms.</p>
						<p>&nbsp;</p>
						<h3>Information Collected Automatically</h3>
						<p>You may visit our sites while remaining anonymous and not reveal any personal information.&nbsp;
							However, our apps and websites use <a href="#_OUR_USE_OF" className={blue}>cookies and similar technologies</a> to automatically log your IP address and domain name, and non-personal information such as the
							type of device you use to access our websites, the operating system and version, your general
							geographic location as indicated by your IP address, your browser type, the webpages you view on
							our websites, and whether and how you interact with content available on our websites.&nbsp;
							This information helps us administer the sites and to compile statistics such as the number of
							visitors.</p>
						<p>&nbsp;</p>
						<h3>Information Obtained From Other Sources</h3>
						<p>On occasion, inMusic may offer in conjunction with third parties, such as software partners, app
							partners, music sharing services and other co-promoted-brand partners, certain products or
							services that may require you to share your personal information with that third party as a
							condition for receiving that product or service. In such circumstances, we may receive
							information about you.&nbsp; We may also receive information about you from social media
							platforms and third-party media hosting sites when you interact with any of our brands on such
							platforms.&nbsp; While inMusic treats any such information it receives from third parties in
							accordance with this Privacy Policy and applies any additional restrictions required by such
							third parties, inMusic is not responsible for the information submitted by you to that third
							party.&nbsp; You should review the applicable rules and any third party&rsquo;s applicable
							privacy policies separately before participating in such product or service.</p>
						<p>&nbsp;</p>
						<h3>Information Of Children</h3>
						<p>While not intended for, nor targeted to children, some of inMusic&rsquo;s applications and
							websites may appeal to children under the age of eighteen.&nbsp; We do not knowingly request or
							collect data from children under eighteen unless we have the consent of a parent or guardian. We
							encourage parents and guardians to spend time online with their children and to participate in
							the interactive activities offered on the sites their children visit.&nbsp; If a parent or
							guardian notifies us or we otherwise learn that a child under eighteen has improperly registered
							or submitted information, we will immediately cancel the child&rsquo;s account and delete all
							personal information of that child from our records.</p>
						<p>&nbsp;</p>
						<h2 id="_TYPICAL_CUSTOMER_INTERACTIONS">TYPICAL CUSTOMER INTERACTIONS WHERE WE MAY COLLECT INFORMATION</h2>
						<p>To assist you in understanding when and how inMusic may collect information, outlined below are
							situations when we potentially collect personal information from you:</p>
						<p>&nbsp;</p>
						<h3>Learning About inMusic And Its Brands</h3>
						<p>inMusic markets and sells a broad range of products for all skill levels from beginner to
							professional.&nbsp; Understandably, customers and prospective customers may want to learn more
							about inMusic&rsquo;s products.&nbsp; In certain circumstances, in addition to us collecting
							information via <a href="#_OUR_USE_OF" className={blue}>cookies and similar technologies</a>, you may voluntarily
							provide personal information, such as your name and email address. We use this information to
							provide updates about product offering, events, contests and other news that customers typically
							wish to receive.</p>
						<p>&nbsp;</p>
						<h3>Buying Our Products</h3>
						<p>Many of our websites offer a &ldquo;Buy Now&rdquo; feature for certain products.&nbsp; To
							complete any purchase, we collect your name, phone number, email address, delivery and shipping
							address(es), and payment information.&nbsp; We use this information to complete your
							transaction, send you order/shipment/delivery notifications and address any other matters
							related to your purchase.&nbsp; <strong>Note that we never store payment or credit card
								information. We only use payment information to complete your purchase.</strong></p>
						<p>&nbsp;</p>
						<h3>Registering Your Products</h3>
						<p>To install any bundled software and download important updates, you will need to register your
							product.&nbsp; During the registration process, you will be required to set up an account (if a
							new customer) and link your product to your new or existing account.&nbsp; The account set up
							requires you to enter personal information such as your name, phone number, email address,
							location data, your password and IP address.&nbsp; We collect your password only for
							authentication and account access.&nbsp; We use this information to ensure your product is set
							up properly and to ensure you receive product notices.</p>
						<p>&nbsp;</p>
						<h3>Getting Help From Us</h3>
						<p>You may occasionally contact our Customer Support group for product assistance.&nbsp; To provide
							the best service to you, we may collect contact information such as your name, email address,
							phone number and the content of our communications (including chats and voice recordings if you
							contact us by phone).&nbsp; We may also collect diagnostic information about your product(s), in
							which case we will notify you specifically in advance.&nbsp; We use this information to provide
							the highest quality and efficient customer support.&nbsp; Contact information is used to respond
							to you in your preferred method and to ensure delivery of any product returns or exchanges.</p>
						<p>&nbsp;</p>
						<h2 id="_HOW_WE_USE">HOW WE USE INFORMATION</h2>
						<p>&nbsp;</p>
						<h3>Product Development and Improvement</h3>
						<p>We use data to develop and improve our products and services, including improving performance,
							developing and adding new features or capabilities.</p>
						<p>&nbsp;</p>
						<h3>Order Fulfilment and Service Information</h3>
						<p>We use data to process and fulfill orders and to send you service information, including
							confirmations, invoices, notices, updates, security alerts, user surveys, and administrative
							messages.</p>
						<p>&nbsp;</p>
						<h3>Customer Support</h3>
						<p>We use data to respond to customer inquiries, diagnose product problems, repair customers&rsquo;
							products and provide other customer care and support.</p>
						<p>&nbsp;</p>
						<h3>Security, Safety and Dispute Resolution</h3>
						<p>We use data to protect the security and safety of our products and our customers, to detect and
							prevent fraud, to resolve disputes and enforce our agreements.</p>
						<p>&nbsp;</p>
						<h3>Product Performance Analysis</h3>
						<p>We use data to analyze product and service usage, feature and content popularity, software and
							hardware quality, market trends, and to improve and influence the design and competitiveness of
							future products and services.</p>
						<p>&nbsp;</p>
						<h3>Communications and Marketing</h3>
						<p>We use data to send you personalized information about inMusic, our products and brands,
							services, and other topics inMusic thinks may be of interest to you, such as brand, product and
							service information or updates. We also use <a href="#_OUR_USE_OF" className={blue}>cookies and similar
								technologies</a> to provide the most relevant advertising to you.&nbsp; For information
							about managing email subscriptions and promotional communications, please visit <a
								href="#_YOUR_RIGHTS_AND" className={blue}>Your Rights and Choices</a>.</p>
						<p>&nbsp;</p>
						<h3>Aggregation and Use of Anonymous Data</h3>
						<p>inMusic aggregates information provided by you to create anonymous statistical and demographic
							data. This anonymous data helps inMusic to understand and know its customer base better. That
							anonymous data may be provided to third parties but never in such a fashion as to identify you
							personally.</p>
						<p>&nbsp;</p>
						<h2 id="_HOW_WE_SHARE">HOW WE SHARE INFORMATION</h2>
						<p><strong>inMusic does not sell your personal information.</strong>&nbsp; We only disclose your
							data as described below.</p>
						<p>&nbsp;</p>
						<h3>Public Forums for User Materials</h3>
						<p>Certain portions of our sites are designed to offer you the opportunity to post information on
							our sites, including but not limited to information about yourself. You should always remember
							that publicly displayed information is public. For example, you may be permitted to post your
							resume information, a video you have created, or to post messages in any chat rooms, message
							boards, mailing lists, and news groups our sites make available to its users. If you use a
							forum, bulletin board or chat room on an inMusic website, you should be aware that any
							information you share is visible to other users. Personally identifiable information you submit
							to one of these forums can be read, collected, or used by other individuals to send you
							unsolicited messages. inMusic is not responsible for the personally identifiable information you
							choose to submit in these forums.</p>
						<p>&nbsp;</p>
						<h3>Third-Party Vendors</h3>
						<p>inMusic uses certain third-party vendors to perform services such as website development,
							management and hosting, ecommerce processing, fraud protection, credit card processing and email
							communications.&nbsp; We only share your personal data as necessary, such as to complete a
							transaction or to provide a product or service you have requested or authorized and only with
							vendors or agents working on our behalf for the purposes described in this Privacy Policy. Your
							personal information will be shared with these agents or contractors only for the purpose of
							performing services on behalf and under instructions of inMusic and in accordance with this
							Privacy Policy.</p>
						<p>&nbsp;</p>
						<h3>inMusic-Controlled Affiliates And Subsidiaries</h3>
						<p>We share information with inMusic-controlled affiliates and subsidiaries for business purposes
							such as internal administration, promoting inMusic products and providing customers with our
							products and services.</p>
						<p>&nbsp;</p>
						<h3>Law Enforcement And Other Compelled Disclosure</h3>
						<p>inMusic discloses your personal information to law enforcement authorities, investigative
							organizations, our affiliates or in legal proceedings when legally required.&nbsp;&nbsp;
							Specifically, inMusic intends to cooperate with any order or official request from law
							enforcement officials or a court of competent jurisdiction for information as to the identity of
							individuals submitting or posting information to inMusic or on this site. Such orders or
							requests supersede the terms of this Privacy Policy.</p>
						<p>&nbsp;</p>
						<h3>Sharing And Disclosure Of Aggregate Data</h3>
						<p>inMusic may share data with third parties in aggregate form or in a form which does not enable
							the recipient of such data to identify you for analysis purposes.</p>
						<p>&nbsp;</p>
						<h3>inMusic Links to Other Sites and Advertising</h3>
						<p>Our sites may display advertisements and/or links to third parties. inMusic is not responsible
							for the privacy practices or the content of those websites. Please refer to that company&rsquo;s
							privacy policy for further information.</p>
						<p>&nbsp;</p>
						<h3>Surveys</h3>
						<p>From time to time, inMusic may make online surveys available to users of our sites. Participation
							in those surveys is voluntary. Some online surveys may ask participants for personal
							information, such as an email address, in addition to requesting answers to survey questions.
							inMusic may use that personal information to contact the participant if necessary, or as
							otherwise described above. inMusic may make the results of any survey publicly available,
							although inMusic will not attribute any particular response to you without your permission.</p>
						<p>&nbsp;</p>
						<h3>Contests</h3>
						<p>On occasion, inMusic may make available to users of our sites, contests, sweepstakes, or similar
							events in which they may qualify for participation. Participation is always voluntary and
							subject to the applicable rules. The rules may ask participants to provide personal information
							as a condition of participation. inMusic may also make the winner&rsquo;s names public, as
							provided in the applicable rules, or as required by law. inMusic may also use that information
							as described above. In some instances, the applicable rules may contain additional or different
							uses for the information you provide; please be sure to review those rules carefully before
							entering.</p>
						<p>inMusic may permit a third party to sponsor a survey, contest, sweepstakes, or other similar
							event with inMusic, such as through posting it on our sites. Such third party events are
							governed solely by any applicable rules, and may require you to provide information to that
							third party as a condition for participation. While inMusic will treat any information it
							receives in accordance with this Privacy Policy, inMusic is not responsible for the information
							gathered by that third party, and inMusic reminds you to review the rules and privacy policies
							separately applicable to those third-party events.</p>
						<p><strong>&nbsp;</strong></p>
						<h2 id="_OUR_BASES_FOR">OUR BASES FOR USING YOUR INFORMATION</h2>
						<p>We rely on certain legal bases to use your personal information.&nbsp; Specifically:</p>
						<p>&nbsp;</p>
						<h3>Your Consent</h3>
						<p>We may use your personal information when you explicitly and clearly tell us we can.</p>
						<p>&nbsp;</p>
						<h3>Performance of a contract</h3>
						<p>The use of your personal information may be necessary to perform the agreement you have with us.
							For example, to complete your purchase of your product, to register and maintain your account,
							to help with delivery issues, to handle returns, to register your product and to make sure that
							your product performs its basic functions in a secure way or to respond to your requests.</p>
						<p>&nbsp;</p>
						<h3>Legitimate interests</h3>
						<p>We may use your personal information for our legitimate interests. For example, we rely on our
							legitimate interest to analyze and improve our products and services and the content on our
							websites and app, to send you notifications about software updates or information about our
							products and services or to use your personal information for administrative, fraud detection or
							legal purposes.</p>
						<p>Where we process your personal information based on our legitimate interest and no opt-out
							mechanism is available to you, you may exercise your right to object by sending an email to <a
								href="mailto:privacy@inmusicbrands.com" className={blue}>privacy@inmusicbrands.com</a>.&nbsp;</p>
						<p>&nbsp;</p>
						<h2 id="_SECURITY,_STORAGE_AND">SECURITY, STORAGE AND RETENTION OF INFORMATION</h2>
						<h3>Security</h3>
						<p>While inMusic is committed to protecting the security of your information, no security system is
							perfect.&nbsp; inMusic employs a variety of reasonable and appropriate technical and
							organizational measures and industry standards to protect against the loss, theft, misuse and
							unauthorized access, disclosure, alteration and destruction of the information under our
							control. Since our sites under general usage do not collect financial information, inMusic uses
							the standard internet connections for those general usage portions of the site, without secured
							sockets.&nbsp;</p>
						<p>In some cases, you may be prompted to register with our sites to undertake a particular site
							activity or obtain a particular service. As part of that registration, you may be asked to
							choose your own password. inMusic reminds you to protect your password, and not provide it to
							others to use. Allowing others to access and use your account and password can compromise the
							security of your information. inMusic disclaims any responsibility or obligation for your
							decision to provide your password to others. Please alert us immediately if you believe your
							password has been misused. Additionally, always log out and close your browser when you finish
							your session. <strong>Please note, we will never ask you to disclose your password.</strong></p>
						<p>&nbsp;</p>
						<h3>Storage</h3>
						<p>Personal data collected by inMusic may be stored and processed in your region, in the United
							States, or in any other country where inMusic or its affiliates, subsidiaries or service
							providers are located or maintain facilities. inMusic has put in place adequate mechanisms to
							protect personal information when it is transferred internationally, for example by using the
							Standard Contractual Clauses as approved by the European Commission.</p>
						<p>&nbsp;</p>
						<h3>Retention</h3>
						<p>inMusic will retain your personal information for as long as we deem it necessary to enable you
							to use the website and your product(s), to provide services to you, to comply with applicable
							laws (including those regarding document retention), resolve disputes with any parties and
							otherwise as necessary to allow us to conduct our business. All personal information we retain
							will be subject to this Privacy Policy and our internal retention guidelines. If you have a
							question about a specific retention period for certain types of personal information we process
							about you, please send an email to <a
								href="mailto:privacy@inmusicbrands.com" className={blue}>privacy@inmusicbrands.com</a>.</p>
						<p><strong>&nbsp;</strong></p>
						<h2 id="_YOUR_RIGHTS_AND">YOUR RIGHTS AND CHOICES</h2>
						<h3>Your Rights</h3>
						<p>You are in control of how your personal information is used by us. Subject to local law, you can
							do this in the following ways:</p>
						<ul>
							<li>you can ask us for a copy of the personal information we hold about you;</li>
						</ul>
						<ul>
							<li>you can inform us of any changes to your personal information, or if you want us to correct
								any of the personal information we hold about you;</li>
						</ul>
						<ul>
							<li>you can ask us to erase, block or restrict the personal information we hold about you, or
								object to particular ways in which we are using your personal information; and</li>
						</ul>
						<ul>
							<li>in certain situations, you can also ask us to send the personal information you have given
								us to a third party.</li>
						</ul>
						<p>Where we are using your personal information on the basis of your consent, you are entitled to
							withdraw that consent at any time. Moreover, where we process your personal information based on
							legitimate interest or the public interest, you have the right to object at any time to that use
							of your personal information.</p>
						<p>We rely on you to ensure that your personal information is complete, accurate and current. Please
							inform us promptly of any changes to, or inaccuracies of, your personal information by
							contacting <a href="mailto:privacy@inmusicbrands.com" className={blue}>privacy@inmusicbrands.com</a>.</p>
						<p>We will respond to your request as soon as possible but certainly within 30 days.&nbsp; We are
							committed to working with you to obtain a fair resolution of any complaint or concern you may
							have about our use of your personal information. If, however, you believe that we have not been
							able to assist with your complaint or concern, you may have the right to lodge a complaint with
							the data protection authority in your country (if one exists in your country) or supervisory
							authority.</p>
						<p>&nbsp;</p>
						<h3>Your Choices</h3>
						<p>If you wish to access, edit or remove profile information, change your password, close your account or request deletion of your personal data, you can do it by logging in to your inMusic account and visiting the <a href="https://profile.inmusicbrands.com/data-privacy/account/" className={blue}>Privacy Center</a> within <a href="https://profile.inmusicbrands.com/customer/account/" className={blue}>My Account</a>.</p>
            <p>If you cannot access certain personal information collected by us via your account or directly via the product that you use, you can always contact us by sending an email to <a href="mailto:privacy@inmusicbrands.com" className={blue}>privacy@inmusicbrands.com</a>. We will respond to any request to access or delete your personal data as soon as possible but certainly within 30 days.</p>
						<p>&nbsp;</p>
						<h3>Your Communication, Marketing and Advertising Preferences</h3>
						<p>Typically, you agree to receive communications when you submit information to our sites. You can
							opt out of receiving direct marketing communications from inMusic by following the instructions
							included in every email sent to you via the &ldquo;Unsubscribe&rdquo; tab. You can also opt out
							of email subscriptions by updating your profile and contact options in your account.&nbsp; You
							can always email our webmaster or customer support team to be removed.&nbsp; We respect your
							choice, and we will stop sending you promotional emails once you unsubscribe or change your
							communication settings.</p>
						<p>Please note, regardless of your communication settings, we will continue to communicate with you
							regarding changes to terms and conditions, policy updates, product software updates, routine
							customer service messages such as information about current or past purchase, delivery of
							products, service interruptions, data breaches or other significant information about a product
							you own such as discontinuation of support or safety issues.</p>
						<p>&nbsp;</p>
						<h2 id="_OUR_USE_OF">OUR USE OF COOKIES AND SIMILAR TECHNOLOGIES</h2>
						<p>inMusic uses cookies and similar technologies to help provide, protect, and improve your browsing
							experience.&nbsp;&nbsp; This policy explains how and why we use these technologies and the
							choices you have.</p>
						<p>A cookie is a small data file that is transferred to your device (e.g. your phone or your
							computer). For example, a cookie could allow us to recognize your browser, while another could
							store your preferences.</p>
						<p>Generally speaking, you may visit our sites while remaining anonymous and not revealing any
							personal information.</p>
						<p>Our websites automatically log your IP address and domain name, and non-personal information such
							as the type of web browser you use, to help us administer the sites and to compile statistics
							such as the number of visitors.</p>
						<p>Our websites use cookies to identify you over multiple visits to the site, for example to
							remember your country and provide country-specific content. Cookies are optional, and you can
							block or delete them. However, some parts of our websites will not work without cookies.</p>
						<p>It is not possible for a cookie stored by us to be read by any other company's website, nor can a
							cookie read information from your computer that you have not already provided to us.</p>
						<p>&nbsp;</p>
						<p><strong>Why inMusic Uses These Technologies</strong></p>
						<p>We use these technologies for a number of purposes, such as:</p>
						<ul>
							<li>To enable you to use and access inMusic&rsquo;s websites.</li>
							<li>To enable, facilitate and streamline the functioning of and your access to the inMusic
								websites.</li>
							<li>To better understand how you navigate through and interact with the inMusic websites and to
								improve the inMusic websites.</li>
							<li>To serve you tailored advertising.</li>
							<li>To show you content (e.g., advertisements) that is more relevant to you.</li>
							<li>To monitor and analyze the performance, operation, and effectiveness of the inMusic websites
								and inMusic advertisements.</li>
							<li>To enforce legal agreements that govern use of the inMusic websites.</li>
							<li>For fraud detection and prevention, and investigations.</li>
							<li>For purposes of our own customer support, analytics, research, product development, and
								regulatory compliance.</li>
						</ul>
						<p>&nbsp;</p>
						<p><strong>Third Parties</strong></p>
						<p>We may also allow certain business partners to place these technologies on the inMusic websites.
							These partners use these technologies to (1) help us analyze how you use the inMusic websites,
							such as by noting the third-party services from which you arrived, (2) market and advertise
							inMusic products and services to you on the inMusic websites and third-party websites, (3) help
							us detect or prevent fraud or conduct risk assessments, or (4) collect information about your
							activities on the inMusic websites, other sites, and/or the ads you have clicked on. For
							example, to help us better understand how people use the inMusic websites, we work with a number
							of analytics partners, including Google Analytics. To prevent Google Analytics from using your
							information for analytics, you may install the Google Analytics Opt-Out Browser by <a
								href="http://tools.google.com/dlpage/gaoptout" className={blue}>clicking here</a>.</p>
						<p>Targeting and advertising cookies we use may include Google, and other advertising networks and
							services we use from time to time. For more information about targeting and advertising cookies
							and how you can opt out, you can visit the <a
								href="http://www.networkadvertising.org/choices/" className={blue}>Network Advertising Initiative&rsquo;s
								opt-out page</a>, the <a href="http://www.aboutads.info/choices/" className={blue}>Digital Advertising
									Alliance&rsquo;s opt-out page</a>, or <a
										href="http://youronlinechoices.eu/" className={blue}>http://youronlinechoices.eu</a>. To opt out of Google
							Analytics for display advertising or customize Google display network ads, you can visit the <a
								href="https://www.google.com/settings/ads" className={blue}>Google Ads Settings</a> page. To the extent
							advertising technology is integrated into the inMusic websites and you opt-out of tailored
							advertising, you may still receive advertising content. In that case, the advertising content
							will just not be tailored to your interests. Also, we do not control any of these opt-out links
							and are not responsible for the availability or accuracy of these mechanisms.</p>
						<p>&nbsp;</p>
						<p><strong>Third Party Social Plugins</strong></p>
						<p>The inMusic websites may use social plugins provided and operated by third parties, such as
							Facebook&rsquo;s Like Button. As a result of this, you may send to the third party the
							information that you are viewing on a certain part of the inMusic websites. If you are not
							logged into your account with the third party, then the third party may not know your identity.
							If you are logged in to your account with the third party, then the third party may be able to
							link information or actions about your interactions with the inMusic websites to your account
							with them. Please refer to the third party&rsquo;s privacy policies to learn more about its data
							practices.</p>
						<p>&nbsp;</p>
						<p><strong>Your Choices</strong></p>
						<p>Most browsers automatically accept cookies, but you can modify your browser setting to decline
							cookies by visiting the Help portion of your browser&rsquo;s toolbar.</p>
						<p>Flash cookies operate differently than browser cookies, and cookie management tools available in
							a web browser will not remove flash cookies. To learn more about how to manage flash cookies,
							you can visit the <a href="http://www.adobe.com/" className={blue}>Adobe website</a> and make changes at the <a
								href="http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager02.html" className={blue}>Global
								Privacy Settings Panel</a>.</p>
						<p>Your mobile device may allow you to control cookies through its settings function. Refer to your
							device manufacturer&rsquo;s instructions for more information.</p>
						<p>If you choose to decline cookies, some parts of the inMusic websites may not work as intended or
							may not work at all.</p>
						<p>&nbsp;</p>
						<h2 id="_OUR_INTERNATIONAL_OPERATIONS">OUR INTERNATIONAL OPERATIONS AND DATA TRANSFERS</h2>
						<p>We operate internationally and transfer information to the United States and other countries for
							the purposes described in this policy.</p>
						<p>The United States, European Economic Area (&ldquo;EEA&rdquo;) Member States, and other countries
							all have different laws. When your information is moved from your home country to another
							country, the laws and rules that protect your personal information in the country to which your
							information is transferred may be different from those in the country in which you live. For
							example, the circumstances in which law enforcement can access personal information may vary
							from country to country. In particular, if your information is in the US, it may be accessed by
							government authorities in accordance with US law.</p>
						<p>To the extent that inMusic is deemed to transfer personal information outside of the EEA, we rely
							separately, alternatively, and independently on the following legal bases to transfer your
							information:</p>
						<p>&nbsp;</p>
						<p><strong>Model Clauses</strong></p>
						<p>The European Commission has adopted standard contractual clauses (also known as Model Clauses),
							which provide safeguards for personal information that is transferred outside of Europe. We
							often use these Model Clauses when transferring personal information outside of Europe. You can
							request a copy of our Model Clauses by emailing <a
								href="mailto:privacy@inmusicbrands.com" className={blue}>privacy@inmusicbrands.com</a>.</p>
						<p>&nbsp;</p>
						<p><strong>Privacy Shield</strong></p>
						<p>inMusic does not participate in Privacy Shield at this time. However, inMusic Europe may rely on
							the EU-US Privacy Shield to transfer personal information to some of our third-party service
							providers in the United States, where they are certified to receive such information under the <a href="https://www.privacyshield.gov/" className={blue}>Privacy Shield Program</a>.</p>
						<p>&nbsp;</p>
						<p><strong>Necessary for the performance of the contract</strong></p>
						<p>inMusic provides a voluntary service; you can choose whether or not you want to use the services.
							However, if you want to use the services, you need to agree to our Terms of Use, which set out
							the contract between inMusic and its members. As we operate in countries worldwide (including in
							the US) and use technical infrastructure in the US to deliver the services to you, in accordance
							with the contract between us, we need to transfer your personal information to the US and to
							other jurisdictions as necessary to provide the services. Simply put, we cannot provide you with
							the services and perform our contract with you without moving your personal information around
							the world.</p>
						<h2 id="_CHANGES_TO_THIS">CHANGES TO THIS PRIVACY POLICY</h2>
						<p>If and when inMusic makes changes to this site, inMusic may have to update this Privacy Policy to
							better reflect those changes. When we update it, we will change the &ldquo;Last Update&rdquo;
							date at the top of this page.&nbsp; Because changes to our sites or updates to this Privacy
							Policy may occur, you should review this Privacy Policy from time to time. Remember, your
							decision to continue using our sites after this Privacy Policy Statement is updated will signify
							that you have agreed to any new terms.</p>
						<p><strong>&nbsp;</strong></p>
						<h2 id="_WHO_WE_ARE">WHO WE ARE AND HOW TO CONTACT US</h2>
						<p>If you have any questions about this privacy statement, the practices of this site, or your
							dealings with this site, please send an email to <a
								href="mailto:privacy@inmusicbrands.com" className={blue}>privacy@inmusicbrands.com</a><strong>.</strong></p>
						<p>Unless otherwise stated, inMusic Brands, Inc. is a data controller for personal data we collect
							subject to this Privacy Policy.&nbsp; Our address is 200 Scenic View Dr., Cumberland, RI 02864
							U.S.A.</p>
						<p>inMusic Europe Limited is our data protection representative for the European Economic Area,
							United Kingdom and Switzerland.&nbsp; The data protection officer of inMusic Europe Limited can
							be contacted at the following address: Unit 3, Nexus Park, Lysons Avenue, Ash Vale, Hampshire
							GU12 5QE, United Kingdom or by email at <a
								href="mailto:privacy@inmusicbrands.com" className={blue}>privacy@inmusicbrands.com</a>.&nbsp;</p>

					</Col>
				</Row>
			</Container>
		</Container>
	)
}
